  $(document).ready(function() {
      $(document).on("click",".tabs-nav li",function() {

      var tab_id = $(this).index();

      // Remove active class from all tabs and add to the clicked tab
      $('.tabs-nav li').removeClass('active');
      $(this).addClass('active');

      // Hide all tab content and show the content of the clicked tab
      $('.tabs-content > div').hide().eq(tab_id).show();
    });

    // Show the initial tab on page load
    $('.tabs-nav li:first').click();
  });